import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center',
      width: '40px',
      height: '40px',
      margin: 'auto'
    },
    checkbox: {
      opacity: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
